import movementRoutes from './routes'

/* @ngInject */
const movementRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(movementRoutes.index.path, {
      url: movementRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'movementCtrl',
      redirectTo: movementRoutes.home.path,
    })
    .state(movementRoutes.home.path, {
      url: movementRoutes.home.url,
      template: require('./templates/home.html'),
    })
}

export default movementRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/movement/movement.routes.js